import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { FiFilter } from "react-icons/fi";
import { FaChevronDown } from "react-icons/fa";

const NotesCardHeader = () => {
  const [bulk, setBulk] = useState("Unmark All");
  const [sort, setSort] = useState("Last Modified");

  return (
    <div className="notes-header-box">
      
      {/* LEFT */}
      <div className="d-flex align-items-center gap-2">
        
        {/* BULK DROPDOWN */}
        <Dropdown>
          <Dropdown.Toggle className="custom-dropdown text-dark ">
            {bulk} <FaChevronDown className="ms-2 arrow" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="custom-menu">
            {["Unmark All", "Delete Marked", "Mark All"].map((item) => (
              <Dropdown.Item
                key={item}
                className={bulk === item ? "active-item" : ""}
                onClick={() => setBulk(item)}
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <button className="apply-btn">Apply</button>
      </div>

      {/* RIGHT */}
      <div className="d-flex align-items-center">
        <Dropdown>
          <Dropdown.Toggle className="custom-dropdown text-dark">
            <FiFilter className="me-2" />
            {sort}
            <FaChevronDown className="ms-2 arrow" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="custom-menu">
            {["Recent", "Last Modified", "Last Modified by me"].map(
              (item) => (
                <Dropdown.Item
                  key={item}
                  className={sort === item ? "active-item" : ""}
                  onClick={() => setSort(item)}
                >
                  {item}
                </Dropdown.Item>
              )
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <style>
          {
               `
               .notes-header-box {
  background: #fff;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

/* DROPDOWN BUTTON */
.custom-dropdown {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 8px 14px !important;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
}

.custom-dropdown::after {
  display: none !important;
}

/* ARROW */
.arrow {
  font-size: 10px;
}

/* APPLY BUTTON */
.apply-btn {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 7px 14px;
  border-radius: 8px;
}

/* DROPDOWN MENU */
.custom-menu {
  border-radius: 8px;
  padding: 5px 0;
  min-width: 180px;
}

/* ITEMS */
.custom-menu .dropdown-item {
  padding: 8px 14px;
  font-size: 14px;
}

/* ACTIVE ITEM (ORANGE EXACT LIKE IMAGE) */
.active-item {
  background: #ff6a00 !important;
  color: #fff !important;
}

/* HOVER */
.custom-menu .dropdown-item:hover {
  background: #f3f4f6;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .notes-header-box {
    gap: 10px;
  }
}`
          }
      </style>
    </div>
  );
};

export default NotesCardHeader;